import type { TextZone } from '@/lib/api';

/**
 * Fold per-zone scale overrides into each zone's absolute `font_size`.
 *
 * The admin cover editor holds a corner-resize gesture as a live `scale`
 * multiplier (an override), NOT by mutating `font_size` on every mousemove —
 * doing the latter compounds (`font × scale` re-applied each move makes the
 * text explode/collapse). The live multiplier is collapsed into `font_size`
 * exactly once, here, at save time.
 *
 * Mirrors the math the previous (buggy) per-move bake used so saved output is
 * unchanged for a single resize: `font_size = round(font_size × scale)`,
 * floored at 6px, with a missing size defaulting to 32.
 */
export function foldZoneScaleOverrides(
  zones: TextZone[],
  overrides: Record<number, { scale?: number } | undefined>,
): TextZone[] {
  return zones.map((z, i) => {
    const scale = overrides[i]?.scale;
    if (scale === undefined || scale === 1) return z;
    return { ...z, font_size: Math.max(6, Math.round((z.font_size ?? 32) * scale)) };
  });
}
